import { observer } from 'mobx-react-lite'
import { useUserInvite } from 'app/components/user-invite/useUserInvite'
import { UserInviteShadcnComponent } from 'app/components/user-invite/UserInviteShadcnComponent'
import { userInviteValidator } from 'app/components/user-invite/userInviteValidator'

export const handle = {
  title: `Add New User`,
}

const InviteUser = observer(function InviteUser(): React.ReactElement | null {
  const hookData = useUserInvite()
  if (!hookData.me) return null
  return (
    <UserInviteShadcnComponent
      {...hookData}
      me={hookData.me}
      currentWorkspaceId={hookData.currentWorkspace?.id || ``}
      validator={userInviteValidator}
    />
  )
})

export default InviteUser
